module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ma-2 elevation-6"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("send")])], 1), _vm._v("\n    " + _vm._s(_vm.title || _vm.value.full_name) + "\n    "), _c('v-spacer'), _vm._v(" "), (_vm.value.phone_number && _vm.context && _vm.sender && _vm.templateSlug) ? _c('form', {
    attrs: {
      "action": "https://unibox.appointmentguru.co/whatsapp/",
      "method": "POST",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "small": "",
      "outline": "",
      "round": "",
      "color": "success"
    }
  }, [_vm._v("WhatsApp\n        "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.phone_number),
      expression: "value.phone_number"
    }],
    attrs: {
      "type": "hidden",
      "name": "to"
    },
    domProps: {
      "value": (_vm.value.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "phone_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "template"
    },
    domProps: {
      "value": _vm.templateSlug
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "context"
    },
    domProps: {
      "value": _vm.parsedContext
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3 py-2 pa-0 ma-0",
    attrs: {
      "label": "email",
      "disabled": !(_vm.value.email) || !_vm.isRealEmail(_vm.value.email),
      "hint": _vm.emailHint(_vm.value),
      "persistent-hint": ""
    },
    model: {
      value: (_vm.byEmail),
      callback: function($$v) {
        _vm.byEmail = $$v
      },
      expression: "byEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3 py-2 pa-0 ma-0",
    attrs: {
      "label": "sms",
      "disabled": !_vm.value.phone_number,
      "hint": _vm.value.phone_number || "No phone number available",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.bySMS),
      callback: function($$v) {
        _vm.bySMS = $$v
      },
      expression: "bySMS"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7525fd8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unibox/RecipientCard.vue
// module id = 1547
// module chunks = 9